import React, { useState } from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { app } from "../../constants/config";
import {
  deletingRepayment,
  updatingRepayment,
} from "../../actions/repaymentActions";
import $ from "jquery";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const DisplayRepayments = (props) => {
  const [ActiveRepayment, setActiveRepayment] = useState({
    id: "",
    bankId: "",
    linker: "",
    name: "",
    description: "",
    createdAt: "",
    updatedAt: "",
  });

  const [Deleting, setDeleting] = useState(false);
  const [Editting, setEditting] = useState(false);

  const saveEdittedRepayment = () => {
    if (/\S/.test(ActiveRepayment.name)) {
      setEditting(true);
      fetch(`${app}/repayment/edit`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${props.banker.token}`,
        },
        body: JSON.stringify({
          ...ActiveRepayment,
          RepaymentId: ActiveRepayment.id,
        }),
      })
        .then((res) => res.json())
        .then((details) => {
          setEditting(false);
          $("#editRepayment").modal("hide");
          if (details.code != 2) {
            props.updatingRepayment(details);
          } else {
            swal({
              title: "Server Error!",
              text: "Please try again",
              icon: "error",
              timer: 3000,
            });
          }
        })
        .catch((err) => {
          setEditting(false);
          swal({
            title: "Connection Error!",
            text: "Check your connection and try again",
            icon: "error",
            timer: 3000,
          });
        });
    } else {
      swal({
        title: "Empty Name!",
        text: "Ensure name is filled",
        icon: "error",
        timer: 3000,
      });
    }
  };

  const GetLandlord = (landlordId) => {
    let landlord = props.Landlords.find(
      (landlord) => landlord.id == landlordId
    );
    return landlord ? landlord : { name: "none", id: 0, housesId: 0 };
  };

  const saveDeletedRepayment = () => {
    setDeleting(true);
    fetch(`${app}/repayment/delete`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${props.banker.token}`,
      },
      body: JSON.stringify({
        ...ActiveRepayment,
        RepaymentId: ActiveRepayment.id,
      }),
    })
      .then((res) => res.json())
      .then((details) => {
        setDeleting(false);
        $("#deleteRepayment").modal("hide");
        if ((details.code = 2)) {
          props.deletingRepayment(details.linker);
        } else {
          swal({
            title: "Server Error!",
            text: "Please try again",
            icon: "error",
            timer: 3000,
          });
        }
      })
      .catch((err) => {
        setDeleting(false);

        swal({
          title: "Connection Error!",
          text: "Check your connection and try again",
          icon: "error",
          timer: 3000,
        });
      });
  };

  const RepaymentsDisplay = props.Repayments.map((Repayment) => (
    <tr>
      <td>{Repayment.month}</td>
      <td>{GetLandlord(Repayment.landlords_id).name}</td>
      <td>{Repayment.amount}</td>
      <td>{Repayment.mode}</td>
      <td>{Repayment.bankerEmail}</td>
      <td>
        {
          new Date(parseInt(Repayment.linker))
            .toISOString()
            .slice(0, 19)
            .replace("T", " ")
            .split(" ")[0]
        }
      </td>
      <td>{Repayment.details}</td>
      <td>
        {" "}
        <button
          className="btn-sm btn-primary rounded-pill"
          onClick={() => setActiveRepayment({ ...Repayment })}
          data-toggle="modal"
          data-target="#editRepayment"
        >
          <FontAwesomeIcon className="mx-2" icon={faEdit} />
        </button>
      </td>
      <td>
        {" "}
        <button
          className="btn-sm btn-danger rounded-pill"
          onClick={() => setActiveRepayment({ ...Repayment })}
          data-toggle="modal"
          data-target="#deleteRepayment"
        >
          <FontAwesomeIcon className="mx-2" icon={faTrash} />
        </button>
      </td>
    </tr>
  ));

  return (
    <>
      <div style={{ width: "100%", overflowX: "scroll" }}>
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              <th scope="column" colSpan={5}>
                Total
              </th>

              <th scope="column" colSpan={4}>
                {" "}
                {props.Repayments.reduce((a, b) => +a + +b.amount, 0)}
              </th>
            </tr>
            <tr>
              <th scope="column">Month</th>
              <th scope="column">Landlord</th>
              <th scope="column">Amount</th>
              <th scope="column">Mode</th>
              <th scope="column">By</th>
              <th scope="column">Date</th>
              <th scope="column">Details</th>
              <th scope="column">Edit</th>
              <th scope="column">Delete</th>
            </tr>
          </thead>
          {RepaymentsDisplay}
        </table>
      </div>
      <div
        id="editRepayment"
        className="modal fade"
        onClick={(e) => e.stopPropagation()}
        style={{ zIndex: 5000 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="text-center capitalize">
                Edit {ActiveRepayment.for} {ActiveRepayment.month} Repayment
              </h5>
            </div>
            <div className="row justify-content-center">
              <div className="col-12 col-6 text-center">
                <div className="card card-primary">
                  <label>Landlord </label>
                  <select
                    className="rounded-pill form-control"
                    onChange={(e) =>
                      setActiveRepayment({
                        ...ActiveRepayment,
                        landlords_id: e.target.value,
                      })
                    }
                  >
                    <option value={0}>Select Landlord</option>
                    {props.Landlords.map((landlord) => (
                      <option key={landlord.id} value={landlord.id}>
                        {landlord.name}
                      </option>
                    ))}
                  </select>
                  <label>Repayment Mode</label>
                  <select
                    className="rounded-pill form-control"
                    onChange={(e) =>
                      setActiveRepayment({
                        ...ActiveRepayment,
                        mode: e.target.value,
                      })
                    }
                  >
                    <option value="cash">Select Repayment Mode</option>
                    <option value="cash">Cash</option>
                    <option value="bank">Bank</option>
                    <option value="electronic">Electronic/M-pesa</option>
                  </select>{" "}
                  <label>For Month</label>
                  <input
                    type="month"
                    className="rounded-pill form-control"
                    placeholder="Select Month"
                    onChange={(e) =>
                      setActiveRepayment({
                        ...ActiveRepayment,
                        month: e.target.value,
                      })
                    }
                  />
                  <label>Amount</label>
                  <input
                    placeholder="Enter Amount To Repayment"
                    value={ActiveRepayment.amount}
                    onChange={(e) =>
                      setActiveRepayment({
                        ...ActiveRepayment,
                        amount:
                          e.target.value.slice(-1) == "-" ||
                          e.target.value.slice(-1) == "." ||
                          !isNaN(e.target.value.slice(-1))
                            ? e.target.value
                            : e.target.value.slice(0, -1),
                      })
                    }
                    className="rounded-pill form-control"
                  />
                  <div>
                    <label>Repayment Details :</label>
                    <input
                      type="text"
                      className="rounded-pill form-control"
                      placeholder="Enter Repayment Details"
                      value={ActiveRepayment.details}
                      onChange={(e) =>
                        setActiveRepayment({
                          ...ActiveRepayment,
                          details: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="col-12 d-flex justify-content-around my-4">
                <button
                  className="btn-xs btn-danger rounded-pill"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                {!Editting ? (
                  <button
                    className="btn-xs btn-primary rounded-pill"
                    onClick={() => saveEdittedRepayment()}
                  >
                    Save
                  </button>
                ) : (
                  <span className="spinner-border text-primary"></span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="deleteRepayment"
        className="modal fade"
        onClick={(e) => e.stopPropagation()}
        style={{ zIndex: 5000 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="text-center capitalize">
                Delete {ActiveRepayment.for} {ActiveRepayment.month} Repayment
              </h5>
            </div>
            <div className="row justify-content-center">
              <div className="col-12 d-flex justify-content-around my-4">
                <button
                  className="btn-xs btn-danger rounded-pill"
                  data-dismiss="modal"
                >
                  Cancel
                </button>

                {!Deleting ? (
                  <button
                    className="btn-xs btn-warning rounded-pill"
                    onClick={() => saveDeletedRepayment()}
                  >
                    Delete
                  </button>
                ) : (
                  <span className="spinner-border text-primary"></span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  banker: state.auth.banker,
  Repayments: state.Repayment.Repayments,
  Landlords: state.Landlord.Landlords,
  Houses: state.House.Houses,
});

export default connect(mapStateToProps, {
  deletingRepayment,
  updatingRepayment,
})(withRouter(DisplayRepayments));
